module.exports = __webpack_public_path__ + "static/media/ETSToeic_logo.8daff169.svg";